import FormPhoneNumberField from './fields/Form/PhoneNumberField.vue'
import DetailPhoneNumberField from './fields/Detail/PhoneNumberField.vue'
import IndexPhoneNumberField from './fields/Index/PhoneNumberField.vue'

const phoneNumberFieldSetup = (app) => {
  app.component('form-phone-number-field', FormPhoneNumberField)
  app.component('detail-phone-number-field', DetailPhoneNumberField)
  app.component('index-phone-number-field', IndexPhoneNumberField)
}

export { phoneNumberFieldSetup }
